import { Box, useBreakpointValue } from '@chakra-ui/react';
import DeveloperTeamIcon from '@/assets/icons/DeveloperTeamIcon';
export default function UnderDevelopment(): React.JSX.Element {
  const size = useBreakpointValue({ base: 300, sm: 450, md: 600 })
  return (
    <Box
      minH="80vh"
      display="flex"
      alignItems="center"
      width="100%"
      pt={30}
    >
      <Box
        maxW="860px"
        margin="0 auto"
        textAlign="center"
      >
        <Box
          fontFamily='"Roboto", sans-serif'
          letterSpacing={2}
          fontWeight={600}
          fontSize={18}
          textAlign="center"
        >
          UNDER DEVELOPMENT
        </Box>
        <Box
          display="flex"
          justifyContent="center"
        >
          <DeveloperTeamIcon width={size} height={size} />
        </Box>
        <Box
          display="flex"
          flexWrap="wrap"
          flex="0 0 auto"
          marginLeft="auto"
          marginRight="auto"
          fontWeight={300}
          fontSize={28}
          textAlign="center"
        >
          Check back for an update soon. Stay in touch!
        </Box>
      </Box>
    </Box>
  );
}
